if (!customElements.get('benefit-card')) {
  customElements.define('benefit-card', class Benefit extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        card: this,
        moreLink: this.querySelector('[class^="benefit-card__more-link"]'),
        closeArrow: this.querySelector('[class^="benefit-card__close-icon"]')
      }

      this.elements.moreLink.addEventListener('click', this.toggleCardView.bind(this));
      this.elements.closeArrow.addEventListener('click', this.toggleCardView.bind(this));
    }

    toggleCardView() {
      var isToggled = this.elements.card.hasAttribute('open');
      if (!isToggled) {
        this.elements.card.setAttribute('open', true);
      } else {
        this.elements.card.removeAttribute('open');
      }
    }
  });
}